// use local storage to manage cart data
const addToDb = id => {
   let shoppingCart = {};

   //get the shopping cart from local storage
   const storedCart = localStorage.getItem('shopping-cart');
   if (storedCart) {
      shoppingCart = JSON.parse(storedCart);
   }

   // add quantity
   const quantity = shoppingCart[id];
   if (quantity) {
      const newQuantity = quantity + 1;
      shoppingCart[id] = newQuantity;
   }
   else {
      shoppingCart[id] = 1;
   }
   localStorage.setItem('shopping-cart', JSON.stringify(shoppingCart));
}



// ata toiri kora hoiche --
const getStoredCart = () => {
   let shoppingCart = {};

   //get the shopping cart from local storage
   const storedCart = localStorage.getItem('shopping-cart');
   if (storedCart) {
       shoppingCart = JSON.parse(storedCart);
   }
   return shoppingCart;
}










//remove from Db
const removeFromDb = id => {
   const storedCart = localStorage.getItem('shopping-cart');
   if (storedCart) {
      const shoppingCart = JSON.parse(storedCart);
      if (id in shoppingCart) {
         delete shoppingCart[id];
         localStorage.setItem('shopping-cart', JSON.stringify(shoppingCart));
      }
   }
}


//delete full shoping cart
const deleteShoppingCart = () => {
   localStorage.removeItem('shopping-cart');
}




//total price ber kora--
const getTotalPrice = products => {
   const reducer = (previous, current) => previous + current.price;
   const total = products.reduce(reducer, 0);
   return total;
}







export {
   addToDb,
   removeFromDb,
   deleteShoppingCart,
   getTotalPrice,
   getStoredCart
}